import * as types from '../types';

export const getSinglePetTreatments = id => ({
  type: types.GET_SINGLE_PET_TREATMENTS_REQUEST,
  payload: {
    id,
  },
});

export const addSingleTreatment = (fileList, id, values, onSuccess) => ({
  type: types.ADD_SINGLE_TREATMENT_REQUEST,
  payload: {
    id,
    values,
  },
  meta: {
    fileList,
    onSuccess,
  },
});

export const sendSmsWithTwilio = (petId, treatmentId, phoneM1, phoneM2, text, petName, onSuccess) => ({
  type: types.SEND_SMS_REQUEST,
  payload: {
    petId,
    treatmentId,
    text,
    phoneM1,
    phoneM2,
    petName,
  },
  meta: {
    onSuccess,
  },
});

export const sendEmail = (petId, treatmentId, email1, email2, vaccination, petName, onSuccess) => ({
  type: types.SEND_EMAIL_REQUEST,
  payload: {
    petId,
    treatmentId,
    email1,
    email2,
    vaccination,
    petName,
  },
  meta: {
    onSuccess,
  },
});

export const getTreatmentData = (petId, treatmentId, onSuccess) => ({
  type: types.GET_TREATMENT_DATA_REQUEST,
  payload: {
    petId,
    treatmentId,
  },
  meta: {
    onSuccess,
  },
});

export const editTreatmentData = (
  petId,
  treatmentId,
  values,
  deletedFileArray,
  fileList,
  onSuccess,
) => ({
  type: types.EDIT_TREATMENT_DATA_REQUEST,
  payload: {
    petId,
    treatmentId,
    values,
    deletedFileArray,
  },
  meta: {
    fileList,
    onSuccess,
  },
});

export const deleteTreatment = (petId, treatmentId, reports, onSuccess) => ({
  type: types.DELETE_TREATMENT_REQUEST,
  payload: {
    petId,
    treatmentId,
    reports,
  },
  meta: {
    onSuccess,
  },
});
